export default {
  name: 'Benefits',
}
